export default __webpack_public_path__ + "static/media/photos_2.4a7b27c7.jpg";